export const LinkIconConfig = Object.freeze({
    logo: "/resources/images/logo/logo.svg",
    policy: "/resources/images/policy/policy.svg",
    headers: {
        toggler: "/resources/images/header/toggler.svg",
        close: "/resources/images/header/close.svg",
    }
});
